import {
  DataModelBuilder, isSameData, SerializationContext, SerializedData,
} from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';
import { PhotoReference } from '../../models/serializable/file-reference/photo-reference.js';

export class CustomImageInfoComponent extends Component {
  static readonly TYPE_ID: string = '95a2440cb0954b3d9e3b84fb2b7f7d51';

  constructor(
    public readonly image: PhotoReference,
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return CustomImageInfoComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): CustomImageInfoComponent {
    return new CustomImageInfoComponent(
        context.fromData<PhotoReference>(MapUtils.get<SerializedData>(map, 'image'))
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'image': context.toData(this.image),
    };
  }

  clone(): this {
    return new CustomImageInfoComponent(
        this.image.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.image, this.image);
  }
}

export class CustomImageInfoComponentBuilder extends DataModelBuilder<CustomImageInfoComponent> {
  build(context: SerializationContext, map: SerializedData): CustomImageInfoComponent {
    return CustomImageInfoComponent.fromMap(context, map);
  }
}
